import React, { useState } from "react";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";

function CheckBoxTypeReTrySA({ type, questionNo, response }) {
    const [isClicked, setIsClicked] = useState(false);
    const [mideaviewer, setMideaviewer] = useState(false);
    const [responseAttach, setResponseAttach] = useState();
    const [isError, setIsError] = useState(false);
    const [pedingSubDetail, setPedingSubDetail] = useState({
        pdfView: false,
    });
    const handleRemovePdfVivwer = () => {
        setPedingSubDetail({
            ...pedingSubDetail,
            pdfView: false,
        });
    };
    const handleClick = (attachment) => {
        setResponseAttach(attachment);
        setIsClicked(!isClicked);
    };

    const poster =
        "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

    const handleClickforpdf = (fileUrl) => {
        setTimeout(() => {
            setResponseAttach(fileUrl);
            setMideaviewer(true);
        }, 100)
    };

    const question = response?.question_response?.question || response?.question_response?.b4sQuestion;


    const truncate = (text, max = 20) =>
        text?.length > max ? text.slice(0, max) + "..." : text;
    return (
        <>
            <div className="containerBelowQuestion">
                <div className="d-flex justify-content-between">
                    <div className="Question">
                        Q{questionNo}.  {question?.title?.split("\n").map((line, index) => (
                            <React.Fragment key={index}>
                                {index !== 0 && <br />}
                                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                                    {line}
                                </span>
                            </React.Fragment>
                        ))}
                    </div>
                    {/* <div className="marksQue">
                    {question?.correct_score} Marks
                  </div> */}
                </div>

                {question?.attachments?.length > 0 &&
                    question?.attachments?.map(
                        (attachment, index) => (
                            <div key={index} style={{ cursor: "pointer" }}>
                                {<>
                                    {attachment.split(".").pop() === "jpg" ||
                                        attachment.split(".").pop() === "jpeg" ||
                                        attachment.split(".").pop() === "JPEG" ||
                                        attachment.split(".").pop() === "JPG" ||
                                        attachment.split(".").pop() === "PNG" ||
                                        attachment.split(".").pop() === "png" ? (
                                        <img
                                            style={{ cursor: "pointer" }}
                                            className="mt-3 imageWidthAndHeight"
                                            src={IP + attachment?.replace(/^\./, "")}
                                            alt="Attachment"
                                            onClick={() => {
                                                if (!isError) {
                                                    handleClick(attachment);
                                                }
                                            }}
                                        />
                                    ) : (
                                        <div
                                            key={index}
                                            onClick={() => handleClickforpdf(attachment)}
                                            className="mt-2"
                                        >
                                            <div className="d-flex pdfContainer gap-2 p-2 ">
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        className="extention_icon"
                                                        src={`${iconData?.find(
                                                            (i) =>
                                                                i.extension ===
                                                                attachment?.match(/\.([^.]+)$/)[1]
                                                        )?.icon
                                                            }`}
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="w-100">
                                                    <div className="pdfName">
                                                        {truncate(attachment?.replace(/^[^_]*_/, ""), 15)}
                                                    </div>
                                                    <div className="pdfFileSize">12 KB</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>}
                            </div>
                        )
                    )
                }
                <div className="mt-4  optionContainer">
                    {question?.options?.length > 0 &&
                        question?.options?.map((option) => {
                            const answerKey = response?.question_response?.answer?.key;

                            const isSelected = answerKey === option?.key;
                            return (
                                <>
                                    <div
                                        key={option?.key}
                                        className={`d-flex justify-content-between align-items-center ${type == "SA" ? question?.correct_answers?.map(
                                            (cAnswer) =>
                                                cAnswer?.optionKey === option?.key
                                                    ? "totalContainerCheckboxCorrectAnswer"
                                                    : cAnswer?.optionKey !==
                                                        response?.question_response?.answer?.key &&
                                                        response?.question_response?.answer?.key === option?.key
                                                        ? "totalContainerCheckboxWrongAnswer"
                                                        : "totalContainerCheckboxNotAnswer"
                                        )
                                            :
                                            question?.correct_answers?.map(
                                                (cAnswer) =>
                                                    cAnswer?.option_key === option?.key
                                                        ? "totalContainerCheckboxCorrectAnswer"
                                                        : cAnswer?.option_key !==
                                                            response?.question_response?.answer?.key &&
                                                            response?.question_response?.answer?.key === option?.key
                                                            ? "totalContainerCheckboxWrongAnswer"
                                                            : "totalContainerCheckboxNotAnswer"
                                            )
                                            }`
                                        }
                                    >
                                        <div className="d-flex align-items-center gap-3 ">
                                            <div className="d-flex">
                                                {
                                                    option?.key + ". "
                                                }
                                                <input
                                                    type="checkbox"
                                                    readOnly
                                                    checked={
                                                        response?.question_response?.answer?.key ===
                                                        option?.key ||
                                                        question?.correct_answers?.some(
                                                            (cAnswer) => (cAnswer?.optionKey || cAnswer?.option_key) === option?.key
                                                        ) ||
                                                        false
                                                    }
                                                    className={`${question?.correct_answers?.some(
                                                        (cAnswer) => type == "SA" ? cAnswer?.optionKey === option?.key : cAnswer?.option_key === option?.key
                                                    )
                                                        ? "CorrectAnswerCheckbox"
                                                        : "WrongAnswerCheckbox"
                                                        } d-flex align-items-center ml-2 mt-1`}
                                                />
                                            </div>
                                            <div className="QueOptionsChecked d-flex align-items-center">
                                                {option?.value}
                                            </div>
                                        </div>
                                        {type == "SA" ? response?.question_response?.answer?.key === option?.key && (
                                            <div
                                                className={` ${question?.correct_answers?.map(
                                                    (cAnswer) =>
                                                        cAnswer?.optionKey === option?.key
                                                            ? "CorrectAnswerText"
                                                            : "yourAnswerText"
                                                )}`}
                                            >
                                                Your answer
                                            </div>
                                        ) : response?.question_response?.answer?.key === option?.key && (
                                            <div
                                                className={` ${question?.correct_answers?.map(
                                                    (cAnswer) =>
                                                        cAnswer?.option_key === option?.key
                                                            ? "CorrectAnswerText"
                                                            : "yourAnswerText"
                                                )}`}
                                            >
                                                Your answer
                                            </div>
                                        )}
                                        {
                                            type == "SA" ? question?.correct_answers
                                                ?.length > 0 &&
                                                question?.correct_answers?.map(
                                                    (cAnswer) =>
                                                        cAnswer?.optionKey === option?.key && (
                                                            <div className="CorrectAnswerText">Correct answer </div>
                                                        )
                                                ) :
                                                question?.correct_answers
                                                    ?.length > 0 &&
                                                question?.correct_answers?.map(
                                                    (cAnswer) =>
                                                        cAnswer?.option_key === option?.key && (
                                                            <div className="CorrectAnswerText">Correct answer </div>
                                                        )
                                                )
                                        }

                                    </div >
                                    <div className="ml-8 mt-1">
                                        {option.attachment && (() => {
                                            const fileUrl =
                                                typeof option.attachment === "string"
                                                    ? option.attachment
                                                    : option.attachment?.url;

                                            if (!fileUrl) return null;

                                            const fileType = fileUrl.split(".").pop().toLowerCase();
                                            const isImage = ["jpg", "jpeg", "png"].includes(fileType);
                                            const isVideo = ["mp4", "mov"].includes(fileType);
                                            const isPdf = fileType === "pdf";

                                            const fileIcon =
                                                iconData?.find((i) => i.extension === fileType)?.icon ||
                                                "/images/file_icon.png";

                                            const fullUrl = fileUrl.startsWith("http")
                                                ? fileUrl
                                                : `${IP}${fileUrl}`;

                                            return (
                                                <div className="d-flex flex-row align-items-center me-3">
                                                    {isImage ? (
                                                        <ZoomableImage src={option.attachment} />
                                                    ) : isVideo ? (
                                                        <video
                                                            src={fullUrl}
                                                            style={{
                                                                width: "60px",
                                                                height: "50px",
                                                                borderRadius: "6px",
                                                                marginBottom: "5px",
                                                            }}
                                                            controls
                                                        />
                                                    ) : isPdf ? (
                                                        <div
                                                            onClick={() => handleClickforpdf(fileUrl)}
                                                            style={{
                                                                width: "100px",
                                                                height: "50px",
                                                                background: "#f5f5f5",
                                                                borderRadius: "6px",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                margin: "6px 0px"
                                                            }}
                                                        >
                                                            <img
                                                                src={fileIcon}
                                                                alt="pdf"
                                                                style={{ width: "24px", height: "24px" }}
                                                            />
                                                            <div className="hw_default_attach_name">
                                                                <span>
                                                                    {truncate(option.attachment?.replace(/^[^_]*_/, ""), 15)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <a
                                                            href={`https://docs.google.com/gview?url=${encodeURIComponent(
                                                                fullUrl
                                                            )}&embedded=true`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ textDecoration: "none" }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: "100px",
                                                                    height: "50px",
                                                                    background: "#f5f5f5",
                                                                    borderRadius: "6px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <img
                                                                    src={fileIcon}
                                                                    alt="file"
                                                                    style={{ width: "24px", height: "24px" }}
                                                                />
                                                            </div>
                                                        </a>
                                                    )}
                                                </div>
                                            );
                                        })()}

                                    </div>
                                </>
                            )
                        })
                    }
                </div>
                {
                    response?.question_response?.answer?.key === " " ? (
                        <div className="d-flex align-items-center">
                            <img src="/images/wrong_icon.svg" alt="" />
                            <div className="m-2 wrong">Student Not Answered</div>
                        </div>
                    ) : type == "SA" ? (
                        question !== undefined ? (
                            question?.correct_answers?.some(
                                (cAnswer) => cAnswer?.optionKey === response?.question_response?.answer?.key
                            ) ? (
                                // If at least one correct answer matches, mark as Correct
                                <div className="mt-4">
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="d-flex align-items-center">
                                            <img src="/HwImg/checkIcon.svg" alt="" />
                                        </div>
                                        <div className="Correct">Correct</div>
                                    </div>
                                </div>
                            ) : (
                                // If no correct answer matches, mark as Wrong
                                <div className="mt-4">
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="d-flex align-items-center">
                                            <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                                        </div>
                                        <div className="wrong">Wrong</div>
                                    </div>
                                </div>
                            )
                        ) : question?.correct_answers?.some(
                            (cAnswer) => cAnswer?.optionKey === response?.question_response?.answer?.key
                        ) ? (
                            <div className="mt-4">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="d-flex align-items-center">
                                        <img src="/HwImg/checkIcon.svg" alt="" />
                                    </div>
                                    <div className="Correct">Correct</div>
                                </div>
                            </div>
                        ) : (
                            <div className="mt-4">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="d-flex align-items-center">
                                        <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                                    </div>
                                    <div className="wrong">Wrong</div>
                                </div>
                            </div>
                        )
                    )
                        : question?.correct_answers?.some(
                            (cAnswer) => cAnswer?.option_key === response?.question_response?.answer?.key
                        ) ? (
                            <div className="mt-4">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="d-flex align-items-center">
                                        <img src="/HwImg/checkIcon.svg" alt="" />
                                    </div>
                                    <div className="Correct">Correct</div>
                                </div>
                            </div>
                        ) : (
                            <div className="mt-4">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="d-flex align-items-center">
                                        <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                                    </div>
                                    <div className="wrong">Wrong</div>
                                </div>
                            </div>
                        )
                }

                {/* <div className='mt-4'>
                        <div className='d-flex align-items-center gap-2'>
                            <div className='d-flex align-items-center'>
                                <img src='/HwImg/CoorectAnswerIcon.png ' alt=''/>  
                            </div>
                            <div className='Corect'>Correct</div>
                        </div>
                    </div> */}

                {!type == "SA" && <div className="mt-4 pt-2">
                    <div className="TeacherRemarkHeader">TEACHER’S REMARK</div>
                    <div className="TeacerRemarkText mt-2">{response?.comment}</div>
                </div>}
            </div >
            {
                mideaviewer && (
                    <PdfViewer
                        closeMideaviewer={setMideaviewer}
                        attachment={responseAttach}
                    />
                )
            }
            {
                isClicked &&
                (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            <video className="videoPlayer" controls>
                                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
                            </video>
                            <div>
                                <img
                                    className="crossIconImgQue"
                                    onClick={handleClick}
                                    src="/DCM-img/crossIcon.svg"
                                    alt="Up Arrow"
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            {
                                !isError ? (
                                    <>

                                        <img
                                            className="imgMain"
                                            src={IP + responseAttach?.replace(/^\./, "")}
                                            alt="Full-size"
                                            onError={(e) => {
                                                setIsError(true)
                                            }}
                                        />
                                        <div>
                                            <img
                                                className="crossIconImgQue"
                                                onClick={handleClick}
                                                src="/images/cross.png"
                                                alt="Up Arrow"
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>

                                        <img
                                            onClick={handleClick}
                                            src="/images/cross.png"
                                            alt="Up Arrow"
                                            style={{ position: "absolute", top: "75px", right: "40%" }}
                                        />
                                        <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                                        <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default CheckBoxTypeReTrySA;
